export default function categoryList() {
    if (window.matchMedia('screen and (min-width: 768px)').matches) {
        loadScrollingCategoryList();
    }

    function loadScrollingCategoryList() {
        const $element = document.querySelector('.category-scroll-list');

        if (!$element) {
            return;
        }

        import('./categoryscroll.js').then(({default: categoryScroll}) => categoryScroll($element));
    }
}
